"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSelected = isSelected;
function isSelected(currentPathname, slug) {
  return currentPathname === '/' && slug === '/' ? true : currentPathname.toLowerCase() === slug.toLowerCase() && slug !== '/';
}